export default __webpack_public_path__ + "cb11cb9090d58075448f5cc2aa01a586.png";